<template>
  <div class="normal-preview-mobiles">
    <div class="mobile-layout">
        <slot name="mobile"></slot>
    </div>
    <div v-if="tabs?.length > 0" class="flex-mobile-tabs">
      <div
        v-for="(n, i) in tabs"
        @click="trunTab(i)"
        class="tab-item"
        :key="i"
        :class="{ active: tabPreviewIndex === i }"
      >
        {{ n }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NormalPreviewMobiles",
  data() {
    return {
      tabPreviewIndex: 0,
    };
  },
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    trunTab(index) {
      this.tabPreviewIndex = index;
      this.$emit("change", index);
    },
  },
};
</script>

<style lang="scss" scoped>
.normal-preview-mobiles {
  width: 375px;
  height: 100%;

  display: flex;
  align-items: center;
  flex-direction: column;

  .mobile-layout {
    width: 100%;
    height: 0;
    flex-grow: 1;
  }

  .flex-mobile-tabs {
    margin-top: 16px;
    margin-bottom: 8px;
    border-radius: 8px;
    border: 3px solid #ffffff;
    background-color: #ffffff;
    display: inline-flex;
    align-items: center;

    .tab-item {
      padding: 0 8px;
      border-radius: 8px;
      line-height: 32px;
      font-size: 13px;
      color: #8a9099;
      cursor: pointer;
      transition: all 0.2s;

      &.active {
        background-color: #f2f7ff;
        color: var(--yd-primary);
      }
    }
  }
}
</style>
